(function () {
  'use strict';

  angular
    .module('neo.home.adminUsers')
    .factory('AdminUsers', function ($resource, EnvironmentConfig) {
      return $resource(EnvironmentConfig.API + '/admin/users/:id', { id: '@id' }, {
        update: { method: 'PUT' }
      });
    })
    .controller('AdminUsersCtrl', AdminUsersCtrl);

  function AdminUsersCtrl($mdDialog, $mdToast, AdminUsers, ajuntaments) {
    var vm = this;
    vm.ajuntaments = ajuntaments;
    vm.users = [];

    load();

    function load() {
      AdminUsers.query(function (data) { vm.users = data; });
    }

    vm.openDialog = function (user) {
      $mdDialog.show({
        templateUrl: 'home/admin-users/admin-users-dialog.tpl.html',
        controller: 'AdminUserDialogCtrl',
        controllerAs: 'vm',
        locals: {
          user: user ? angular.copy(user) : { role: 'AJUNTAMENT', enabled: true, allowedAjuntamentIds: [] },
          ajuntaments: ajuntaments,
          isNew: !user
        }
      }).then(function (saved) {
        load();
        showToast(saved ? 'Usuari desat correctament' : 'Usuari eliminat');
      });
    };

    vm.deleteUser = function (user, $event) {
      var confirm = $mdDialog.confirm()
        .title('Eliminar usuari')
        .textContent('Segur que vols eliminar ' + user.email + '?')
        .ok('Eliminar').cancel('Cancel·lar')
        .targetEvent($event);
      $mdDialog.show(confirm).then(function () {
        AdminUsers.delete({ id: user.id }, function () {
          load();
          showToast('Usuari eliminat');
        });
      });
    };

    function showToast(msg) {
      $mdToast.show($mdToast.simple().textContent(msg).position('bottom right').hideDelay(3000));
    }
  }

  angular
    .module('neo.home.adminUsers')
    .controller('AdminUserDialogCtrl', AdminUserDialogCtrl);

  function AdminUserDialogCtrl($mdDialog, $mdToast, AdminUsers, user, ajuntaments, isNew) {
    var vm = this;
    vm.user = user;
    vm.ajuntaments = ajuntaments;
    vm.isNew = isNew;
    vm.roles = [
      { value: 'ADMIN',      label: 'Administrador' },
      { value: 'AJUNTAMENT', label: 'Ajuntament' }
    ];

    vm.isAjuntamentSelected = function () {
      return vm.user.role === 'AJUNTAMENT';
    };

    vm.toggleAjuntament = function (id) {
      var ids = vm.user.allowedAjuntamentIds || [];
      var idx = ids.indexOf(id);
      if (idx === -1) { ids.push(id); } else { ids.splice(idx, 1); }
      vm.user.allowedAjuntamentIds = ids;
    };

    vm.hasAjuntament = function (id) {
      return (vm.user.allowedAjuntamentIds || []).indexOf(id) !== -1;
    };

    vm.save = function () {
      if (isNew) {
        AdminUsers.save(vm.user, function () { $mdDialog.hide(true); }, onError);
      } else {
        AdminUsers.update({ id: vm.user.id }, vm.user, function () { $mdDialog.hide(true); }, onError);
      }
    };

    vm.cancel = function () { $mdDialog.cancel(); };

    function onError() {
      $mdToast.show($mdToast.simple().textContent('Error en desar l\'usuari').position('bottom right').hideDelay(3000));
    }
  }
}());
